import { Event, SDK, ServerOptions } from '@commercetools/frontend-sdk';
import type { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';
import type {
  StoreActions,
  FindStoreResult,
  FindStorePayload,
  FindStoreAvailabilityPayload,
} from '../../types/actions/StoreActions';

export const getStoreActions = (sdk: SDK<ComposableCommerceEvents>): StoreActions => {
  return {
    findStore: async (
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
        payload?: FindStorePayload;
      } = {},
    ) => {
      const response = await sdk.callAction<FindStoreResult>({
        actionName: 'availability/findStore',
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload: options.payload,
      });

      if (!response.isError) {
        sdk.trigger(
          new Event({
            eventName: 'storeAvailabilityFetched',
            data: {
              transactionId: response.data?.transactionId,
              storePickupInfos: response.data?.storePickupInfos,
            },
          }),
        );
      }

      return response;
    },
    availabilityTimeStamp: async (
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
        payload?: FindStoreAvailabilityPayload;
      } = {},
    ) => {
      const response = await sdk.callAction<FindStoreResult>({
        actionName: 'availability/availabilityTimeStamp',
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
        payload: options.payload,
      });
 
      if (!response.isError) {
        sdk.trigger(
          new Event({
            eventName: 'storeAvailabilityFetched',
            data: {
              transactionId: response.data?.transactionId,
              storePickupInfos: response.data?.storePickupInfos,
            },
          }),
        );
      }
 
      return response;
    },
  };
};
